import { Container as PixiContainer } from 'pixi.js';

export default class Container extends PixiContainer {
  [propName: string]: any;
}
